import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'fr',
  months: [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre',
  ],
  monthsShort: ['jan', 'fév', 'mar', 'avr', 'mai', 'juin', 'jui', 'août', 'sep', 'oct', 'nov', 'déc'],
  weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
  weekdaysMin: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  weekdaysShort: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY HH:mm',
    'lll-Y': 'D MMM HH:mm',
    llll: 'ddd, D MMM YYYY HH:mm',
    'llll-Y': 'ddd, D MMM HH:mm',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([UTC]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([UTC]Z)',
  },
  past: {
    y: { one: 'il y a %s a', other: 'il y a %s a' },
    M: { one: 'il y a %s m.', other: 'il y a %s m.' },
    w: { one: 'il y a %s sem.', other: 'il y a %s sem.' },
    d: { one: 'il y a %s j', other: 'il y a %s j' },
    h: { one: 'il y a %s h', other: 'il y a %s h' },
    m: { one: 'il y a %s min', other: 'il y a %s min' },
    s: { one: 'il y a %s s', other: 'il y a %s s' },
  },
  future: {
    y: { one: 'dans %s a', other: 'dans %s a' },
    M: { one: 'dans %s m.', other: 'dans %s m.' },
    w: { one: 'dans %s sem.', other: 'dans %s sem.' },
    d: { one: 'dans %s j', other: 'dans %s j' },
    h: { one: 'dans %s h', other: 'dans %s h' },
    m: { one: 'dans %s min', other: 'dans %s min' },
    s: { one: 'dans %s s', other: 'dans %s s' },
  },
  abbr: {
    y: { one: '%s an', other: '%s ans' },
    M: { one: '%s m', other: '%s m' },
    w: { one: '%s sem', other: '%s sem' },
    d: { one: '%s j', other: '%s j' },
    h: { one: '%s h', other: '%s h' },
    m: { one: '%s min', other: '%s mins' },
    s: { one: '%s s', other: '%s s' },
  },
  justNow: "à l'instant",
  yesterday: 'Hier',
  today: "Aujourd'hui",
  tomorrow: 'Demain',
  weekStart: 1,
};
const localeName: LocaleName = 'fr';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
